import Passthrough from 'components/consumer/Passthrough';

// In the new consumer app we always render children for all devices as
// required by React 18.
const AboveTheFoldServerRenderer = Passthrough;

export default AboveTheFoldServerRenderer;
